// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604150803/js/" + chunkId + "." + {"44":"f0e1bc39","225":"a084c365","481":"66fc474c","486":"20990ef7","770":"9c338d29"}[chunkId] + ".0.9192845748554488.chunk.js";
};